import gql from "graphql-tag";

export const UPADTE_USER = gql`
  mutation update_user($is_profile_setup: Boolean!, $userId: uuid!) {
    update_users(
      _set: { is_profile_setup: $is_profile_setup }
      where: { id: { _eq: $userId } }
    ) {
      affected_rows
    }
  }
`;
